import styled from 'styled-components';
import { Type } from '@spotify-internal/encore-web';
import { screenMdMin } from '@spotify-internal/encore-foundation';
import {
  AnimationContextType,
  DELAYS,
  fadeInAnimation,
  withAnimationContext,
} from './Animations';

export const Headline = withAnimationContext(
  styled(Type.h1).attrs({
    variant: Type.heading1,
    weight: Type.bold,
  })<{ centered?: boolean; animationContext: AnimationContextType }>`
    ${fadeInAnimation(DELAYS.SECOND)};
    @media (min-width: ${screenMdMin}) {
      text-align: ${({ centered }) => (centered ? 'center' : 'left')};
    }
  `,
);
